import { AppManifestV0 } from './app-manifest-v0';
import { AppManifestV1 } from './app-manifest-v1';
import { AppManifestV2 } from './app-manifest-v2';

type SomeVersion = AppManifestV0 | AppManifestV1 | AppManifestV2;

type DetectedVersion = 'V0' | 'V1' | 'V2';

// Na versão V0 o 'name' é armazenado diretamente na raiz do manifesto ao invés da propriedade 'config'
const isV0 = (json: AppManifestV0) =>
  typeof json.name === 'string' && typeof json.entrypoint === 'string';

// Na versão V1 o 'name' é armazenado na propriedade 'config'
const isV1 = (json: AppManifestV1) =>
  json.config != null &&
  typeof json.config.name === 'string' &&
  typeof json.entrypoint === 'string';

// Na V2 passamos a explicitar a versão da propriedade manifestVersion
const isV2 = (json: AppManifestV2) => json.manifestVersion === 'V2';

const detectManifestVersion = (
  manifest: SomeVersion | unknown,
): DetectedVersion | null => {
  if (isV1(manifest as AppManifestV1)) {
    return 'V1';
  }
  if (isV0(manifest as AppManifestV0)) {
    return 'V0';
  }

  if (isV2(manifest as AppManifestV2)) {
    return 'V2';
  }

  return null;
};

export { DetectedVersion, SomeVersion };

export default detectManifestVersion;
